var map = {
	"./bg-noise.png": "2a9b",
	"./circle-yellow-.png": "3108",
	"./circle-yellow.png": "9468",
	"./circle.png": "d215",
	"./logo-dark.svg": "a599",
	"./logo-vim.png": "a83f",
	"./logo-vim.svg": "aec0",
	"./melati-dots.png": "c783",
	"./melatie-lines.png": "2ffc",
	"./menu-logo.png": "fa48",
	"./scroll-indicator.png": "3d27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";